






























import { Vue,Component } from 'vue-property-decorator'
import { State,Action,namespace } from 'vuex-class'
const basis = namespace('basis') //getMailList
const common = namespace('common')
@Component
export default class Home extends Vue{
    daterange:any = [] //时间
    @basis.State('smsPager') pager:any //表格的页码
    @basis.State('smsList') list:any //快递员列表
    @basis.State('loading') loading:any //快递员列表
    get search(){
        let star = ''
        let end = ''
        if(this.daterange){
            star = this.daterange[0]
            end = this.daterange[1]
        }
        return {
            phone: '',
            star: star,
            site:'',
            end: end,
            page: 1
        }
    }
    get tablecolumn(){
        return [
            {
                prop: 'site',
                type: 'nextProp',
                label: '网点',
                nextProp: 'name'
            },
            {
                prop: 'content',
                type: 'text',
                label: '内容',
                width: '300px',

            },
            {
                prop: 'msgid',
                type: 'text',
                label: '短信ID',
            },
            {
                prop: 'type',
                type: 'text',
                label: '类型',

            },
            {
                prop: 'phone',
                type: 'text',
                label: '电话',

            },
            {
                prop: 'ctime',
                type: 'text',
                label: '创建时间',

            },
        ]
    }
    @basis.Action('getSmsList') getSmsList:any
    created(){
        this.getList()
    }
    getList(){
        this.getSmsList(this.search)
    }
    // 翻页
    pagechange(e:any){
        this.search.page = e[0].val
        this.getList()
    }
    // 网点改变的时候
    changeSite(val:string){
        console.log(val);
        
        this.search.site = val
        this.getList()
    }
}
